// formConfig.js
const cnpjMask = [
  /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/
];

export const formStructure = [
  // Row 0
  [
    {
      name: 'numeroDoPedido',
      label: 'Número do Pedido',
      placeholder: 'Digite o número do pedido',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      required: true,
      maxLength: 50,
      disabled: true,
      validation: { required: 'Número do pedido é obrigatório' }
    },
    {
      name: 'numeroPedidoEmbarcador',
      label: 'Número do pedido do embarcador',
      placeholder: 'Ex.: 12345',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      maxLength: 50,
      required: true,
      validation: { required: 'Número do pedido do embarcador é obrigatório' }
    }
    // {
    //   name: 'numeroEmbarcador',
    //   label: 'Número Embarcador',
    //   placeholder: 'Digite o número do embarcador',
    //   component: 'FormField',
    //   type: 'text',
    //   colProps: { md: 6 }
    // }
  ],

  // Row 1
  [
    {
      name: 'dataAgendamento',
      label: 'Data de Agendamento',
      placeholder: 'Selecione a data de agendamento',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 6 }
    }
  ],

  // Row 2 - Básicos adicionais
  [
    {
      name: 'localPalletizacao',
      label: 'Local de Paletização',
      placeholder: 'Digite o local de paletização',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      maxLength: 255
    },
    {
      name: 'numeroDePallets',
      label: 'Número de Pallets',
      placeholder: 'Ex.: 28.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 6 }
    },
    {
      name: 'pesoLiquido',
      label: 'Peso Líquido',
      placeholder: 'Ex.: 28.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 6 }
    },
    {
      name: 'pesoDoPedido',
      label: 'Peso do Pedido',
      placeholder: 'Ex.: 26.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 6 }
    }
  ],

  // Row 3 - Textos curtos
  [
    {
      name: 'tipoDeRemetente',
      label: 'Tipo de Remetente',
      placeholder: 'Ex.: Pessoa',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'CubagemPedido',
      label: 'Cubagem do pedido (M3)',
      placeholder: 'Ex.: 26.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 6 }
    }
  ],

  // Row 4 - Remetente/Destinatário
  [
    {
      name: 'remetente',
      label: 'Remetente',
      placeholder: 'Razão Social / Doc',
      component: 'SelectWithModal',
      colProps: { md: 6 }
    },
    {
      name: 'destinatario',
      label: 'Destinatário',
      placeholder: 'Razão Social / Doc',
      component: 'SelectWithModal',
      colProps: { md: 6 }
    },
    {
      name: 'recebedor',
      label: 'Recebedor',
      placeholder: 'Selecione o recebedor',
      component: 'SelectWithModal',
      colProps: { md: 6 }
    }
  ],

  // Row 5 - Origem/Destino/Rotas
  [
    {
      name: 'origem',
      label: 'Origem',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'destino',
      label: 'Destino',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'rota',
      label: 'Rota (código de integração)',
      placeholder: 'Selecione a rota',
      component: 'SelectWithModal',
      colProps: { md: 12 }
    }
  ],

  // Row 6 - Operação/Carga/Empresa/Modelo
  [
    {
      name: 'tipoDeCarga',
      label: 'Tipo de Carga',
      placeholder: 'Ex.: Vazio',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'tipoDeOperacao',
      label: 'Tipo de Operação',
      placeholder: 'Ex.: Deslocamento coleta',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'empresaFilial',
      label: 'Empresa/Filial',
      placeholder: 'Digite o CNPJ',
      component: 'MaskedInput',
      type: 'text',
      mask: cnpjMask,
      inputMode: 'numeric',
      parse: (value) => String(value ?? '').replace(/\D/g, ''),
      colProps: { md: 6 }
    },
    {
      name: 'modeloVeicularSolicitado',
      label: 'Modelo veicular solicitado',
      placeholder: 'Ex.: Carreta 6 eixos ls',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    }
  ],

  // Row 7 - Datas (datetime)
  [
    {
      name: 'dataColeta',
      label: 'Data de Coleta',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataPrevisaoSaida',
      label: 'Data previsão Saída',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataPrevisaoEntregaRemetente',
      label: 'Data previsão entrega/remetente',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataAgendamentoPedido',
      label: 'Data agendamento (pedido)',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    }
  ],

  // Row 8 - Execução/Faturamento (datetime)
  [
    {
      name: 'dataInicialViagemExecutada',
      label: 'Data inicial viagem executada',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataFinalViagemExecutada',
      label: 'Data final viagem executada',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataInicialViagemFaturada',
      label: 'Data inicial viagem faturada',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataFinalViagemFaturada',
      label: 'Data final viagem faturada',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    }
  ],

  // Row 9 - Demais
  [
    {
      name: 'tomador',
      label: 'Tomador',
      placeholder: 'Ex.: COMANDO LOG...',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 }
    },
    {
      name: 'tipoTomador',
      label: 'Tipo do Tomador',
      placeholder: 'Selecione o tipo do tomador',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      options: [
        { value: '0', label: 'Remetente' },
        { value: '1', label: 'Expedidor' },
        { value: '2', label: 'Recebedor' },
        { value: '3', label: 'Destinatário' },
        { value: '4', label: 'Outros' }
      ]
    },
    {
      name: 'requisitante',
      label: 'Requisitante',
      placeholder: 'Selecione o requisitante',
      component: 'SearchSelect',
      type: 'search',
      colProps: { md: 3 },
      options: [
        { value: '0', label: 'Remetente' },
        { value: '1', label: 'Destinatário' },
        { value: '2', label: 'Outros' },
        { value: '3', label: 'Redespacho' },
        { value: '4', label: 'Terceiro' },
        { value: '5', label: 'Recebedor' }
      ]
    },
    {
      name: 'quantidadeDeEntrega',
      label: 'Quantidade de entrega',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'condicaoDoPedido',
      label: 'Condição do pedido',
      placeholder: 'Ex.: Depósito bancário (formas de pagamento)',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 }
    },
    {
      name: 'valorTotalMercadoria',
      label: 'Valor total da mercadoria',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'valorFrete',
      label: 'Valor do frete negociado',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 }
    },
    {
      name: 'observacaoComplemento',
      label: 'Observação complemento',
      component: 'FormField',
      type: 'text',
      maxLength: 2000,
      colProps: { md: 12 }
    }
  ],

  [
    {
      name: 'duimp',
      label: 'DUIMP',
      placeholder: 'Digite a DUIMP',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 }
    },
  ],

  // Row 10 - Observação
  [
    {
      name: 'observacaoPedido',
      label: 'Observação do pedido',
      type: 'text',
      colProps: { md: 12 }
    }
  ]
];

export const formSections = () => [
  {
    title: 'Detalhes do Pedido',
    rows: [0, 1, 2, 3]
  },
  {
    title: 'Participantes e Locais',
    rows: [4, 5, 6]
  },
  {
    title: 'Datas e Execução',
    rows: [7, 8, 9]
  },
  {
    title: 'Condições e Observações',
    rows: [10, 11]
  }
];

// Validação: mantém somente as regras originais (novos campos são opcionais)
const validateWithStructure = (values, structure, excludedFields = []) => {
  const errors = {};
  const excluded = new Set(['valorFrete', ...excludedFields]);

  const isEmptyValue = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim().length === 0;
    if (value instanceof Date) return Number.isNaN(value.getTime());
    if (typeof value === 'object') {
      if ('value' in value) {
        const v = value.value;
        return v === null || v === undefined || v === '';
      }
      return Object.keys(value).length === 0;
    }
    return false;
  };

  structure.forEach((row) => {
    row.forEach((field) => {
      const name = field?.name;
      if (!name || excluded.has(name)) return;
      if (!field?.component) return; // n�o renderiza input
      if (field?.disabled || field?.readOnly) return; // n�o exigir campos travados
      if (isEmptyValue(values?.[name])) {
        errors[name] = 'Campo obrigatório';
      }
    });
  });

  return errors;
};

export const validateForm = (values) => validateWithStructure(values, formStructure);

const depotHiddenFields = new Set([
  'numeroDoPedido',
  'localPalletizacao',
  'dataAgendamento',
  'numeroDePallets',
  'tipoDeRemetente',
  'CubagemPedido',
  'origem',
  'destino',
  'dataPrevisaoSaida',
  'dataPrevisaoEntregaRemetente',
  'dataAgendamentoPedido',
  'dataInicialViagemExecutada',
  'dataFinalViagemExecutada',
  'dataInicialViagemFaturada',
  'dataFinalViagemFaturada',
  'quantidadeDeEntrega',
  'condicaoDoPedido'
]);

const sectionGroups = [
  {
    title: () => `Detalhes do Pedido `,
    rows: [0, 1, 2, 3]
  },
  {
    title: () => 'Participantes e Locais',
    rows: [4, 5, 6]
  },
  {
    title: () => 'Datas e Execução',
    rows: [7, 8]
  },
  {
    title: () => 'Condições e Observações',
    rows: [9, 10, 11]
  }
];

const applyDepotOverrides = (row) =>
  row.map((field) => {
    if (field.name === 'tipoDeCarga') {
      return {
        ...field,
        component: 'SelectWithModal',
        placeholder: 'Clique para selecionar o tipo de carga'
      };
    }
    if (field.name === 'tipoDeOperacao') {
      return {
        ...field,
        component: 'SelectWithModal',
        placeholder: 'Clique para selecionar a operação'
      };
    }
    if (field.name === 'modeloVeicularSolicitado') {
      return {
        ...field,
        component: 'SelectWithModal',
        placeholder: 'Clique para selecionar o modelo'
      };
    }
    if (field.name === 'tomador') {
      return {
        ...field,
        component: 'SelectWithModal',
        placeholder: 'Clique para selecionar o tomador'
      };
    }

    return field;
  });

export const getFormStructure = (options = {}) => {
  if (!options.isDepot) return formStructure;

  return formStructure
    .map((row) => applyDepotOverrides(row).filter((field) => !depotHiddenFields.has(field.name)))
    .filter((row) => row.length > 0);
};

export const validateFormDepot = (values) =>
  validateWithStructure(values, getFormStructure({ isDepot: true }), ['recebedor']);

export const getFormSections = (structure, initialValues, options = {}) => {
  if (!options.isDepot) return formSections(initialValues);

  const rowIndexMap = new Map();
  let newIndex = 0;

  formStructure.forEach((row, originalIndex) => {
    const filteredRow = row.filter((field) => !depotHiddenFields.has(field.name));
    if (filteredRow.length > 0) {
      rowIndexMap.set(originalIndex, newIndex);
      newIndex += 1;
    }
  });

  return sectionGroups
    .map((group) => ({
      title: group.title(initialValues),
      rows: group.rows
        .map((originalRow) => rowIndexMap.get(originalRow))
        .filter((mappedRow) => mappedRow !== undefined)
    }))
    .filter((section) => section.rows.length > 0);
};




